import { Subsystem, MenuItems, LOCALIZED_MENU_ITEM_TITLE_SYMBOL, SUBSYSTEMS_ROUTES } from './types';
import { Injectable } from '@angular/core';
import { TranslatorService } from '../../infra/common/localization/lang/translator.service';
import { Router } from '@angular/router';
import { McbRoutes } from '../routing/types';

@Injectable({
    providedIn: 'root'
})
export class SubsystemManager {
    readonly subsystems = new Array<Subsystem>();

    constructor(
        private translator: TranslatorService
    ) {
    }

    register(subsystem: Subsystem, externalRoutes?: McbRoutes) {
        this.validateSubsystem(subsystem);
        this.localizeSubsystem(subsystem);
        this.subsystems.push(subsystem);
        for (const item of externalRoutes) {
            SUBSYSTEMS_ROUTES.push(item);
        }
        console.log(subsystem);
    }

    private localizeSubsystem(ss: Subsystem) {
        const localizeMenuItems = (items: MenuItems) => {
            for (const item of items) {
                item[LOCALIZED_MENU_ITEM_TITLE_SYMBOL] = this.translator.translate(item.titleKey, ss);

                if (Array.isArray(item.children)) {
                    localizeMenuItems(item.children);
                }
            }
        };

        if (Array.isArray(ss.menuItems)) {
            localizeMenuItems(ss.menuItems);
        }
    }

    private validateSubsystem(ss: Subsystem) {
        // Do Validation here
    }
}
